import React, { useEffect } from "react";
import { Spin, Icon } from "antd";

import { request } from "~/components/Instance";

var SUPABASE_URL = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SUPABASE_URL) || '';
var SUPABASE_ANON_KEY = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SUPABASE_ANON_KEY) || '';

function fetchSupabaseToken() {
    return request('GET', '/supabase-token', null, false).then(function(res) {
        return res && res.data && res.data.token;
    });
}

// Modern Chrome enforces COOP on instagram.com, which severs the popup's
// window.opener relationship after OAuth. We handle both flows: opener present
// (postMessage + close) and opener missing (do the token exchange here and
// redirect back to the settings page).
var InstagramOAuthCallback = function() {
    useEffect(function() {
        var params = new URLSearchParams(window.location.search);
        var code = params.get('code');
        var error = params.get('error_description') || params.get('error');
        var settingsUrl = '/configuracoes/integracoes/instagram';

        var hasOpener = false;
        try { hasOpener = !!window.opener && !window.opener.closed; } catch (e) { hasOpener = false; }

        if (hasOpener) {
            if (code) {
                window.opener.postMessage({ type: 'instagram_oauth_code', code: code }, window.location.origin);
            } else if (error) {
                window.opener.postMessage({ type: 'instagram_oauth_error', error: error }, window.location.origin);
            }
            setTimeout(function() { window.close(); }, 300);
            return;
        }

        if (error) {
            window.location.replace(settingsUrl + '?ig_error=' + encodeURIComponent(error));
            return;
        }
        if (!code) {
            window.location.replace(settingsUrl);
            return;
        }

        var redirectUri = window.location.origin + '/oauth/instagram';
        fetchSupabaseToken()
            .then(function(token) {
                if (!token) throw new Error('no-token');
                return fetch(SUPABASE_URL + '/functions/v1/instagram-oauth', {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'apikey': SUPABASE_ANON_KEY,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ code: code, redirect_uri: redirectUri }),
                });
            })
            .then(function(res) {
                if (res && res.ok) {
                    window.location.replace(settingsUrl + '?ig_status=success');
                } else {
                    return res.json().then(function(b) {
                        var msg = (b && b.error) || 'connect-failed';
                        window.location.replace(settingsUrl + '?ig_error=' + encodeURIComponent(msg));
                    }, function() {
                        window.location.replace(settingsUrl + '?ig_error=connect-failed');
                    });
                }
            })
            .catch(function(err) {
                window.location.replace(settingsUrl + '?ig_error=' + encodeURIComponent((err && err.message) || 'connect-failed'));
            });
    }, []);

    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16 }}>
            <Icon type="instagram" style={{ fontSize: 48, color: '#E1306C' }} />
            <Spin size="large" />
            <div style={{ color: '#595959' }}>Concluindo conexão com Instagram…</div>
        </div>
    );
};

export default InstagramOAuthCallback;
